module.exports = __webpack_public_path__ + "img/L1.1d77e112.png";